import { __decorate, __metadata } from "tslib";
import { LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber, IsOptional, IsString, Min } from 'class-validator';
import { DefaultStoreExposeGroup } from '../interface';
export class DefaultStoreIntervalSettingsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 45, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], DefaultStoreIntervalSettingsDto.prototype, "duration", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: '-' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 50, { groups: [DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], DefaultStoreIntervalSettingsDto.prototype, "separator", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'hh:mm a' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 50, { groups: [DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], DefaultStoreIntervalSettingsDto.prototype, "format", void 0);
//# sourceMappingURL=DefaultStoreIntervalSettingsDto.js.map